import { render, staticRenderFns } from "./AssetDetailsModal.vue?vue&type=template&id=6dacd1d2&scoped=true&"
import script from "./AssetDetailsModal.vue?vue&type=script&lang=js&"
export * from "./AssetDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./AssetDetailsModal.vue?vue&type=style&index=0&id=6dacd1d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dacd1d2",
  null
  
)

export default component.exports